const transformarData = (data: string) => {
  const [ano, mes, dia] = data.split('T')[0].split('-');
  return `${dia}/${mes}/${ano}`;
};

function limitarString(texto: string, maxLength: number) {
  if (texto.length > maxLength) {
    return texto.slice(0, maxLength - 3) + '...';
  }
  return texto;
}

function formatarPhone(numero: string | undefined) {
  return `(${numero?.slice(0, 2)}) ${numero?.slice(2, 7)}-${numero?.slice(7)}`;
}

function formatCPF(cpf: string) {
  cpf = cpf.replace(/\D/g, '');

  if (cpf.length <= 11) {
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }

  return cpf;
}

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function convertDateToISO (date: string) {
  const [day, month, year] = date.split('/');
  return `${year}-${month}-${day}`; 
};

function normalizePath (path: string) {
  const decoded = decodeURIComponent(path); 
  const parts = decoded.split('/');          
  const last = parts.pop() || '';            
  return last
    .trim()                                 
    .toLowerCase()                          
    .replace(/\s+/g, '-');                  
};

export {
  transformarData,
  limitarString,
  formatarPhone,
  capitalizeFirstLetter,
  formatCPF,
  convertDateToISO,
  normalizePath
};
